export default __webpack_public_path__ + "static/media/yt-play-icon.11d995ed.svg";